module.exports = __webpack_public_path__ + "img/nadvorie_cover.7e1ef32e.jpg";